import { defineStore } from 'pinia'
import { rootState } from '../stores/hydrate.js'

const { __account, __user, ...initialRootState } = structuredClone(rootState)

export const useRootStore = defineStore('root', {
  state: () => {
    return {
      isOnline: true,
      __env: null,
      __version: null,
      __csrfToken: null,
      __sessionTraceId: null,
      __error: null,
      __features: {},
      __initialState: {},
      __browserLogger: {},
      __app: {},
      ...initialRootState
    }
  },
  getters: {
    supportLink(state) {
      return state.__features.support_link
    }
  },
  actions: {
    async setIsOnline(value) {
      this.isOnline = value

      if (!value) {
        const { useViewerUIStore } = await import('./viewer-ui.js')
        const viewerUIStore = useViewerUIStore()
        if (viewerUIStore.isLive) {
          viewerUIStore.setLessMode()
        }
      }
    }
  }
})
